
import Vue, { PropType } from 'vue';
import { Customer } from '@sageworks/jpi/';
import { CustomComponentType } from '@sageworks/dynamic-forms';
import EntityRepeater from '../entity-repeater/entity-repeater.vue';
import { mapState } from 'vuex';
import { getDataObjectsDetails, getRowDetails } from '../../utils/repeater-widget';
import { ValidationConfig } from '../../validation';

export default Vue.extend({
	name: 'CreditApplicantEntity',
	components: { EntityRepeater },
	props: {
		entityTypes: {
			type: Array as PropType<Customer.TypeEnum[]>,
			default: () => []
		},
		componentLabel: {
			type: String,
			default: () => ''
		},
		validationConfig: {
			type: Object as PropType<ValidationConfig>
		},
		componentId: {
			type: String,
			required: true
		},
		allowAddingEntities: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		...mapState('MultiLoanApplicationForm', ['renderData']),
		templateDataFieldMappings(): { [templateDataFieldId: number]: number } {
			return this.directStore.state.CustomComponentProperties.templateDataFieldIdToDataFieldId ?? {};
		},

		mappings() {
			return this.renderData.formData.creditApplicantMappings ?? null;
		},
		dataObjectsDetails() {
			return getDataObjectsDetails(this.mappings, this.renderData.formData.dataObjects);
		},
		rowDetails() {
			return getRowDetails(this.dataObjectsDetails, this.templateDataFieldMappings);
		},
		myComponentType() {
			return CustomComponentType.creditApplicantEntity;
		}
	}
});
